module.exports = __webpack_public_path__ + "img/hwKf.8e99b990.png";